import { useEffect, useRef } from 'react';
import {
  select,
  extent,
  format,
  timeFormat,
  timeDay,
  scaleBand,
  range,
  timeDays,
  scaleDiverging,
  interpolateRdBu,
  scaleSequential,
  interpolateReds,
  axisTop,
  axisLeft,
} from 'd3';

const DensityChart = ({ data }) => {
  const svgRef = useRef();

  useEffect(() => {
    if (!data) return;

    const width = 954;
    const margin = { top: 70, right: 0, bottom: 0, left: 40 };
    const dateExtent = extent(data, (d) => d.date);
    console.log('dateExtent', dateExtent);
    const height = margin.top + margin.bottom + (timeDay.count(...dateExtent) + 1) * 10;
    const formatMonth = timeFormat('%b %-d');
    const x = scaleBand(range(24), [margin.left, width - margin.right]).round(true);
    const y = scaleBand(
      timeDays({
        start: timeDay.floor(dateExtent[0]),
        stop: timeDay.ceil(dateExtent[1]),
        step: 1,
      }),
      [margin.top, height - margin.bottom],
    ).round(true);
    const color = (t) => {
      let [min, max] = extent(data, (d) => d.qty);
      if (min < 0) {
        max = Math.max(-min, max);
        return scaleDiverging([-max, 0, max], (t) => interpolateRdBu(1 - t));
      }
      return scaleSequential([0, max], interpolateReds);
    };

    const xAxis = (g) =>
      g
        .attr('transform', `translate(0,${margin.top})`)
        .call(axisTop(x).tickFormat(formatHour))
        .call((g) => g.select('.domain').remove());

    const yAxis = (g) =>
      g
        .attr('transform', `translate(${margin.left},0)`)
        .call(axisLeft(y).tickFormat(formatDay))
        .call((g) => g.select('.domain').remove());

    const formatUsage = format('.2f');
    const formatDate = timeFormat('%B %-d, %-I %p');
    const formatDay = (d) => (d.getDate() === 1 ? formatMonth : formatDate)(d);
    const formatHour = (d) => (d === 0 ? '12 AM' : d === 12 ? '12 PM' : (d % 12) + '');

    const svg = select(svgRef.current);

    svg.attr('viewBox', [0, 0, width, height]).style('background', 'white');

    svg.append('g').call(xAxis);
    svg.append('g').call(yAxis);

    svg
      .append('g')
      .selectAll('rect')
      .data(data)
      .join('rect')
      .attr('x', (d) => x(new Date(d.date).getHours()))
      .attr('y', (d) => y(timeDay(d.date)))
      .attr('width', x.bandwidth() - 1)
      .attr('height', y.bandwidth() - 1)
      .attr('fill', (d) => color(d.qty))
      .append('title')
      .text((d) => `${formatDate(d.date)} ${formatUsage(d.qty)} kW`);
  }, [data]);

  return <svg ref={svgRef}></svg>;
};

export default DensityChart;
